interface Task {
  requestId: string;
  promise: () => Promise<any>;
  resolve: (value: unknown) => void;
  reject: (reason?: any) => void;
}

export class TaskQueue {
  queue: Task[];
  MAX_CALLS: number;
  TIME_WINDOW: number;
  processing: boolean;

  constructor() {
    this.queue = [];
    this.MAX_CALLS = 60;
    this.TIME_WINDOW = 1 * 60 * 1000; // min * seg * ms
    this.processing = false;
  }

  pushRequest = (promise: () => Promise<any>, requestId: string) => {
    return new Promise((resolve, reject) => {
      this.removeRequest(requestId);
      // Add the promise to the queue.
      this.queue.push({
        requestId,
        promise,
        resolve,
        reject,
      });

      // If the queue is not being processed, we process it.
      if (!this.processing) {
        this.processing = true;
        setTimeout(() => {
          this.processQueue();
        }, this.TIME_WINDOW / this.MAX_CALLS);
      }
    });
  };

  processQueue = async () => {
    const item = this.queue.shift();
    if (item) {
      // console.log("Processing Queue item: " + item.requestId);
      try {
        // Pull first item in the queue and run the request.
        const data = await item.promise();
        item.resolve(data);
        if (this.queue.length > 0) {
          this.processing = true;
          setTimeout(() => {
            this.processQueue();
          }, this.TIME_WINDOW / this.MAX_CALLS);
        } else {
          this.processing = false;
        }
      } catch (e: any) {
        // if (e?.response?.status === 401) {
        //   // Handle unauthorized error specifically if needed
        //   console.log("Unauthorized request - 401");
        //   window.parent.postMessage(
        //     { type: "REQUEST_ACCESS_TOKEN" },
        //     "*" // or parent origin for security
        //   );
        //   window.location.reload();
        // }
        item.reject(e);
      }
    }
  };

  removeRequest = (requestId: string) => {
    // We delete the promise from the queue using the given id.
    this.queue.some((item, index) => {
      if (item.requestId === requestId) {
        this.queue.splice(index, 1);
        return true;
      } else {
        return false;
      }
    });
  };
}
